import React from 'react';
import Egg from 'products/global/assets/img/notfound/egg.png';
import StyledNotFound from './styled';

const NotFoundPage = () => {
  return <StyledNotFound linkTo="/" imageSrc={Egg} imageAlt="Cracked egg illustration" />;
};

export default NotFoundPage;
